module.exports = __webpack_public_path__ + "img/david-guetta-listen-again.568933e1.jpg";